"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const octicons_1 = require("@nteract/octicons");
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const IconWrapper = styled_components_1.default.span.attrs(props => ({
    style: { color: props.color }
})) `
  vertical-align: middle;
  text-align: center;
  opacity: 0.95;
`;
IconWrapper.displayName = "IconWrapper";
class Icon extends React.PureComponent {
    render() {
        let icon = React.createElement(octicons_1.FileText, null);
        switch (this.props.fileType) {
            case "notebook":
                icon = React.createElement(octicons_1.Book, null);
                break;
            case "directory":
                icon = React.createElement(octicons_1.FileDirectory, null);
                break;
            case "file":
                icon = React.createElement(octicons_1.FileText, null);
                break;
            default:
                icon = React.createElement(octicons_1.FileText, null);
        }
        return React.createElement(IconWrapper, { color: this.props.color }, icon);
    }
}
exports.Icon = Icon;
Icon.defaultProps = {
    color: "#0366d6",
    fileType: "file"
};
exports.default = Icon;
